import {Model} from "./Model";
import {IApiMatchResultReport, IApiMatchResultReportRound} from "../typings/apiResponse";

export class MatchResultReport extends Model {
    constructor(private apiData: IApiMatchResultReport) {
        super(apiData);
    }

    public isUserAbsent(): boolean {
        return this.apiData.contestants.self.absent;
    }

    public isOpponentAbsent(): boolean {
        return this.apiData.contestants.opponent.absent;
    }

    public userResultConfirmed(): boolean {
        return this.apiData.contestants.self.resultConfirmed;
    }

    public opponentResultConfirmed(): boolean {
        return this.apiData.contestants.opponent.resultConfirmed;
    }

    public getRounds(): IApiMatchResultReportRound[] {
        return this.apiData.rounds;
    }
}